const initialState = {
    guidedTours : {
        "t1" : false,
        "t2" : false,
        "t3" : false,
        "t4" : false,
    },
    showHowDoesItWorksPopup: false
};

const guidedToursReducer = ( state = initialState, action ) => {
    switch (action.type){
        case "GUIDED_TOURS":
            state = {
                ...state,
                guidedTours: {
                    ...state.guidedTours,
                    ...action.payload
                }
            };
            break;
        default :
            break;
    }
    return state;
};

export default guidedToursReducer;